<template>
  <div id="tenants-slim-list">
    <div v-if="!minimum">
      <vs-table
        search
        pagination
        ref="table"
        :data="tenants"
        :stripe="stripe"
        :max-items="itemsPerPage"
        noDataText="Sem dados disponíveis"
      >
        <template slot="header">
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4" v-if="modifyItensPerPage">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">
              {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{ tenants.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : tenants.length }} de {{ queriedItems }}
            </span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage=4">
                <span>4</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=15">
                <span>15</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=20">
                <span>20</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </template>

        <template slot="thead">
          <vs-th v-if="checkbox" style="width: 50px;">
            <vs-checkbox v-model="selectedAll" :vs-value="true"/>
          </vs-th>
          <vs-th sort-key="fqdn">
            Nome
          </vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td v-if="checkbox">
                <vs-checkbox v-model="selecteds" :vs-value="tr.id"/>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium truncate">{{ parseName(tr.fqdn) }}</p>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
    <div v-else>
      <div :key="indextr" v-for="(tr, indextr) in tenants" class="flex mb-2">
        <vs-td>
          <vs-checkbox v-model="selecteds" :vs-value="tr.id" :title="parseName(tr.fqdn)">
            <div class="flex">
              <p class="align-self-center">{{ parseName(tr.fqdn) }}</p>
            </div>
          </vs-checkbox>
        </vs-td>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    props: {
      checkbox: {
        type: Boolean,
        required: false
      },
      selecteds: {
        required: false,
        default(){ return [] },
        validator: prop => typeof prop === 'object' || prop === null
      },
      minimum: {
        type: Boolean,
        required: false,
        default(){ return false }
      },
      stripe: {
        type: Boolean,
        required: false,
        default(){ return true }
      },
      modifyItensPerPage: {
        type: Boolean,
        required: false,
        default(){ return true }
      },
    },
    data() {
      return {
        isMounted: false,
        selectedAll: false,
        itemsPerPage: 4,
        settings: {
          maxScrollbarLength: 60,
          wheelSpeed: .60
        }
      }
    },
    computed: {
      ...mapGetters(['token', 'tenants']),
      currentPage() {
        if (this.isMounted) return this.$refs.table.currentx
        return 0
      },
      queriedItems() {
        return this.$refs.table ? this.$refs.table.queriedResults.length : this.tenants.length
      }
    },
    methods:{
      parseName(fqdn){
        return fqdn ? fqdn.split(".")[0] : null;
      }
    },
    watch: {
      selecteds() {
        this.$emit("selectedTenant", this.selecteds);
      },
      selectedAll(value){
        if (value){
          this.selecteds = this.tenants.map((tenant) => { return tenant.id; });
        } else {
          this.selecteds = [];
        }
      }
    },
    mounted() {
      this.isMounted = true;
    },
    created() {
      if ( !this.tenants.length ) this.$store.dispatch('getAllTenants', { token: this.token })
    }
  }
</script>
